"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipV3 = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
var TooltipV3 = function (_a) {
    var children = _a.children, message = _a.message, top = _a.top, left = _a.left, width = _a.width, maxWidth = _a.maxWidth, classNameContainer = _a.classNameContainer;
    return (react_1.default.createElement(styles_1.ContainerTooltip, { "data-testid": "tooltip-test", className: classNameContainer },
        children,
        react_1.default.createElement(styles_1.TooltipMessage, { top: top, left: left, width: width, maxWidth: maxWidth }, message)));
};
exports.TooltipV3 = TooltipV3;
